var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.local.loading)?_c('div',{staticClass:"column is-6",class:{ 'is-offset-6': _vm.commentType === 'is-info' }},[_c('b-message',{attrs:{"title":_vm.commentTitle,"aria-close-label":"Close message","type":_vm.commentType,"closable":false}},[_vm._v(" "+_vm._s(_vm.comment.comment)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }